var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTacchinoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1901 17.04C37.7201 16.57 40.6701 16.43 43.2901 16.59C44.5701 16.67 45.2801 15.11 44.3401 14.24C42.0701 12.11 39.5701 10.95 36.1401 10.37",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7001 47.19C30.7001 47.19 24.5001 27.98 26.3201 22.21C26.4501 21.78 28.0301 19.72 28.7201 18.92",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.31 5.18002C33.77 5.07002 36.1901 7.53002 36.1901 11.81C36.1901 15.29 33.4101 20.26 33.7201 22.55C33.9201 24.03 36.61 27.45 35.2 29.48C34.25 30.85 31.7601 30.31 30.8001 29.08C29.0401 26.82 30.1801 21.19 28.9401 18.65C27.2601 15.2 30.2101 8.49002 28.5001 6.25002C26.0701 3.07002 15.5601 0.700021 9.86005 5.72002C3.67005 11.17 4.55005 21.31 7.51005 26.46C9.43005 29.8 10.21 35.84 9.04004 39.8",
    stroke: "#8B1B1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTacchinoRed);
export default __webpack_public_path__ + "static/media/ic_tacchino_red.95099d7fda842f81c7f04d0ababfe7a1.svg";
export { ForwardRef as ReactComponent };